const slider = document.querySelector('.contains-card--product');
let isDown = false;
let startX;
let scrollLeft;
// $('.playvideo').on('click touchstart', function () {
//   const videoElement = document.getElementById('vid');
//   if (videoElement) {
//     if (videoElement.playing) {}
//     else {
//         videoElement.play();
//     }
//   }
// });

if (slider) {
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
  });
}

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $(".template-index sticky-header.header-wrapper").addClass("smoothHeaderTransition");
    $(".temp-impact sticky-header.header-wrapper").addClass("smoothHeaderTransition");
  } else {
    $(".template-index sticky-header.header-wrapper").removeClass("smoothHeaderTransition");
    $(".temp-impact sticky-header.header-wrapper").removeClass("smoothHeaderTransition");
  }
});

$(window).on('load', function () {
    // $('.playvideo').trigger('click');
  // console.log(window)
  
    // player.on('ready', function () { player.play(); });
});
 
$(document).ready(function() {
    // $('.playvideo').trigger('click');
    $(window).on("resize", function (e) {
        checkScreenSize();
    });

    checkScreenSize();
    
    function checkScreenSize(){
      var newWindowWidth = $(window).width();
      
      if (newWindowWidth < 767) {
        $('.botttomannouncement').addClass('owl-carousel');
        $('.owl-carouse.botttomannouncementl').owlCarousel({
          loop:true,
          margin:10,
          responsiveClass:true,
          items: 1
        });
      }
      
      // $('.arne-color-swatch-containers').owlCarousel({
      //   loop: true,
      //   margin: 12,
      //   dots: false,
      //   nav: true,
      //   center: true,
      //   responsiveClass: true,
      //   responsive: {
      //     0: {
      //         items: 4
      //     },
      //     600: {
      //         items: 4
      //     },
      //     1000: {
      //         items: 5
      //     }
      //   }
      // });
      
      var caro = $('.caro').owlCarousel({
        loop: true,
        margin: 10,
        dots: true,
        nav: true,
        center: true,
        responsiveClass: true,
        responsive: {
          0: {
              items: 4
          },
          600: {
              items: 4
          },
          1000: {
              items: 5
          }
        }
      });

      caro.on('changed.owl.carousel', function(event) {
        var title = $('.caro .owl-item.active.center li').attr('product_title');
        var price = $('.caro .owl-item.active.center li').attr('product_price');
        var url = $('.caro .owl-item.active.center li').attr('product_url');
        var img1 = $('.caro .owl-item.active.center li').attr('product_img1');
        var img2 = $('.caro .owl-item.active.center li').attr('product_img2');        

        $('.product_swatches_carousel h2').html(title);
        $('.product_swatches_carousel .price_carousel').html(price);
        $('.buynow_pr_listing').attr('href', url);

        $('.imgone_ele').attr('src', img1);
        $('.imgtwo_ele').attr('src', img2);
      })
      
      var nxt = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">';
          nxt += '<path d="M0.999693 1.07422L8.00146 8.07245L0.999692 15.0742" stroke="black"/></svg>';
      var prev = '<svg xmlns="http://www.w3.org/2000/svg" width="9" height="16" viewBox="0 0 9 16" fill="none">';
          prev += '<path d="M7.99982 15.0742L0.998047 8.07599L7.99982 1.07422" stroke="black"/></svg>';
      $('.caro .owl-next').html(nxt);
      $('.caro .owl-prev').html(prev);
    
      $('.slider_ele').owlCarousel({
        loop: true,
        margin: 20,
        stagePadding: 50,
        items: 1,
        dots: false,
        nav: true,
        responsiveClass: true,
        responsive: {
          0: {
              items:1
          },
          600: {
              items:2
          },
          1000: {
              items:3
          }
        }
      });
    }

  $('form#FacetFiltersFormMobile summary').click(function(e){
    e.preventDefault();
    e.stopPropagation();
  });
  $('#menu-drawer summary').click(function(e){
    e.preventDefault();
    e.stopPropagation();
  });

  

  $('summary.mobile-facets__open-wrapper').click(function(){
    $('form#FacetFiltersFormMobile summary.mobile-facets__summary').parent('details').attr('open', true);
  });
  $('#Details-menu-drawer-container summary').click(function(){
    $('#menu-drawer').find('details').attr('open', true);
  });
  $(".nav_link_wrapper li").click(function() {
    $('html, body').animate({
        scrollTop: $("#product_details_links").offset().top - 100
    }, 2000);
  });
});
